import styled from "styled-components";

export const IndexFilterStyled = styled.div`
 #create-new-view {
  display: none;
 }

 .Polaris-IndexFilters__ActionWrap span:first-child {
  order: 1 !important;
 }

 .Polaris-IndexFilters__ActionWrap span:nth-child(2) {
  order: 3 !important;
 }

 .Polaris-IndexFilters__ActionWrap div:last-child {
  order: 2 !important;
 }

`

export const HeadingStyled = styled.div<{minWidth?: string, isPointer?: boolean}>`
  cursor: ${(props) => props.isPointer ? 'pointer' : ''};
  min-width: ${(props) => props.minWidth || '55px'};
  .Polaris-Text--headingXs {
    font-weight: 550;
  }
`

export const LinkStyled = styled.a<{ removeUnderline?: boolean }>`
  cursor: pointer;
  text-decoration: ${({ removeUnderline }) => (removeUnderline ?? true ? 'none' : 'underline')};
  color: #005bd3;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;


export const DatePickerStyled = styled.div`
.Polaris-DatePicker__Header {
  top: 5%;
  left: 5%;
  width: 90%;
}
`

export const CustomColumn = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const CenterHeading = styled.div`
  text-align: center;
`

export const ButtonStyled = styled.div`
  padding: 0;
`

export const MaxWidthCell = styled.div`
  width: 225px;
  word-break: break-word;
  white-space: pre-line;
`

export const CustomPaddingBox = styled.div`
.Polaris-IndexTable__TableCell--first,
.Polaris-IndexTable__Table--sticky .Polaris-IndexTable__TableCell--first + .Polaris-IndexTable__TableCell, 
.Polaris-IndexTable__StickyTable .Polaris-IndexTable__TableCell--first + .Polaris-IndexTable__TableCell {
        position: sticky;
        z-index: 999px !important;
        background: #ffffff !important;
    }

`

export const MinWidthCell = styled.div`
  min-width: 130px;
  word-break: break-word;
  white-space: pre-line;
`